import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CreateAnnouncementRequest } from '../models/request/create-announcement-request.model';
import { AnnouncementSearchRequest } from '../models/request/announcement-search-request.model';
import { AnnouncementSearchResponse } from '../models/response/announcement-search-response.model';

@Injectable({
  providedIn: 'root',
})
export class AnnouncementService {
  private ctrlUrl = `${environment.apiUrl}/v1/Announcement`;

  constructor(private http: HttpClient) {}

  create(request: CreateAnnouncementRequest): Observable<unknown> {
    return this.http.post(`${this.ctrlUrl}`, request);
  }

  /** POST /v1/Announcement/search - get paged list with filters */
  search(request: AnnouncementSearchRequest): Observable<AnnouncementSearchResponse> {
    return this.http.post<AnnouncementSearchResponse>(`${this.ctrlUrl}/search`, request);
  }

  /** POST /v1/Announcement/daily/search - get daily announcements (bell panel & view all list) */
  dailySearch(request: { page: number; pageSize: number; frequency?: string; keyword?: string; status?: string }): Observable<AnnouncementSearchResponse> {
    return this.http.post<AnnouncementSearchResponse>(`${this.ctrlUrl}/daily/search`, request);
  }

  /** GET /v1/Announcement/:id - get single announcement (for edit) */
  getById(id: string): Observable<unknown> {
    return this.http.get(`${this.ctrlUrl}/${id}`);
  }

  /** PUT /v1/Announcement - update announcement (id in request body) */
  update(request: CreateAnnouncementRequest): Observable<unknown> {
    return this.http.put(`${this.ctrlUrl}`, request);
  }

  /** DELETE /v1/Announcement/:id - delete announcement */
  delete(id: string): Observable<unknown> {
    return this.http.delete(`${this.ctrlUrl}/${id}`);
  }

  /** POST /v1/Announcement/read - mark announcement(s) as read */
  markSingleRead(id: string): Observable<unknown> {
    return this.http.post(`${this.ctrlUrl}/read`, { ids: [id] });
  }

  /** POST /v1/Announcement/read - mark multiple announcements as read */
  markAllRead(ids: string[]): Observable<unknown> {
    return this.http.post(`${this.ctrlUrl}/read`, { ids });
  }
}
